import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../actions/exportLayoutActions2";

import TreeItem from "../tree/TreeItem";
import TextWithHighlightedSearchTerms from "../tree/TextWithHighlightedSearchTerms";

import { DragSource } from "react-dnd";
import { DragDropTypes } from "../../helpers/constants";

type Props = {
    scope: boolean,
    enabledFeatures: Array<string>,
};

class ObjectListEntry extends React.Component<Props> {
    componentDidMount() {
        $(this.divNode).tooltip();
    }

    componentWillUnmount() {
        $(this.divNode).tooltip("destroy");
    }

    handleClick = e => {
        const { onSelectObject, objectId } = this.props;
        if (onSelectObject) {
            onSelectObject(e, objectId);
        }
    };

    render() {
        const { object, selectedObjectIds, objectId, connectDragSource } = this.props;
        if (!object) {
            return null;
        }

        const active = selectedObjectIds && selectedObjectIds.includes(objectId);

        const displayText =
            object.DisplayName != object.ExportName
                ? object.DisplayName + " (" + object.ExportName + ")"
                : object.ExportName;
        return connectDragSource(
            <div
                data-container="body"
                data-toggle="tooltip"
                data-placement="right"
                ref={node => (this.divNode = node)}
                onClick={this.handleClick}
                style={{ userSelect: "none" }}
            >
                <TreeItem active={active}>
                    <TextWithHighlightedSearchTerms text={displayText} />
                </TreeItem>
            </div>
        );
    }
}

// Prop Types /
const propTypes = {
    // Provided from outside
    objectId: PropTypes.any,
    object: PropTypes.object,
    selectedObjectIds: PropTypes.array,
    onSelectObject: PropTypes.func,
    connectDragSource: PropTypes.func.isRequired,
};
ObjectListEntry.propTypes = propTypes;

// Drag and Drop here
function collect(connect, monitor) {
    // React-dnd will inject these props into our component
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging(),
    };
}

const fieldSource = {
    canDrag(/* props */) {
        return true;
    },
    beginDrag(props) {
        // Return data describing the dragged item
        const selectedObjectIds = props.selectedObjectIds || [];
        const objectIds = selectedObjectIds.includes(props.objectId) ? selectedObjectIds : [props.objectId];
        return {
            object: props.objectId,
            objects: objectIds,
            scope: props.scope,
        };
    },
};

const ObjectListEntryDND = DragSource(DragDropTypes.LAYOUTOBJECT, fieldSource, collect)(ObjectListEntry);

// Redux //
const mapStateToProps = (state, ownProps) => ({
    variableId: ownProps.variableId,
    userId: state.session.userId,
    enabledFeatures: state.session.enabledFeatures || [],
});
const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

const ObjectListEntryDNDC = connect(mapStateToProps, mapDispatchToProps)(ObjectListEntryDND);

export default ObjectListEntryDNDC;
